<style lang="scss" scoped>
.trainerlist-outer {
  //border:1px solid red;
  $width-lg: 992px;
  .scrolltotop-box {
    position: fixed;
    right: 15px;
    bottom: 15px;
    background: $c-medium-gray;
    padding: 8px 10px;
    svg {
      width: 25px;
      height: 25px;
    }
  }
  header {
    //position:fixed;
    //width:100%;
    padding: 50px 0;
    //background:$c-medium-gray;
    background: #f7efe5;
    [class*='col-'] {
      //border:1px solid blue;
    }
    .logo {
      height: 150px;
      margin-bottom: 20px;
      border-right: 1px solid #d7d0c7;
      @media (max-width: $width-lg) {
        border-right: 0;
      }
      img {
        max-height: 100%;
        display: block;
        margin: 10px auto;
      }
    }
    h1 {
      @media (max-width: $width-lg) {
        text-align: center;
      }
    }
    p {
      margin-bottom: 30px;
      @media (max-width: $width-lg) {
        text-align: center;
      }
    }
    .dropdown {
      //border:1px solid blue;
      margin-bottom: 20px;
      .btn {
        overflow: hidden;
      }

      .dropdown-menu {
        padding: 10px;
        border-radius: 0;
        max-height: 200px;
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: #ccc #eee;
        width: 100%;
        &::-webkit-scrollbar {
          width: 12px;
        }
        &::-webkit-scrollbar-track {
          background: #eee;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #ccc;
          border-radius: 20px;
          border: 3px solid #eee;
        }
        li {
          padding: 3px;
          &:hover {
            background: $c-medium-gray;
          }
        }
      }
    }
    .btn-edit,
    .btn-save {
      background: $c-dark-blue !important;
      color: #fff !important;
      border: 1px solid $c-dark-blue !important;
    }
  }
  .box-list-outer {
    //border:1px solid red;
    padding-top: 50px;
    padding-bottom: 100px;
    [class*='col-'] {
      //border:1px solid blue;
    }
    .no-results {
      text-align: center;
      font-size: 1.3rem;
      padding: 20px;
      background: $c-medium-grey;
    }
  }

  .box.new {
    cursor: pointer;
    padding: 15px;
    background: $c-medium-grey;
    svg {
      transition: all 200ms ease;
    }
    &:hover {
      svg {
        transform: rotate(90deg);
      }
    }
  }
}
</style>

<template>
  <div class="trainerlist-outer">
    <div class="scrolltotop-box"><Icon :path="mdiChevronUp" :height="30" :width="30" /></div>
    <header>
      <div class="container">
        <div class="row">
          <div class="col-lg-3">
            <div class="logo">
              <img src="@/assets/0220-2101-HR-Visual-RGB-dunkel.svg" />
            </div>
          </div>
          <div class="offset-lg-1 col-lg-8 align-self-center">
            <h1>Trainerliste</h1>
            <p>Eine vollständige Liste unserer Trainer:innen</p>

            <div class="row">
              <div class="col-lg-4">
                <div class="dropdown">
                  <button class="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    {{ ort == '' ? 'Ort' : ort }}
                  </button>
                  <ul class="dropdown-menu">
                    <li @click="setOrt('')">Alle Orte</li>
                    <li @click="setOrt('Wien')">Wien</li>
                    <li @click="setOrt('Graz')">Graz</li>
                    <li @click="setOrt('Klagenfurt')">Klagenfurt</li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="dropdown">
                  <button class="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    {{ focus == '' ? 'Schwerpunkte' : focus }}
                  </button>
                  <ul class="dropdown-menu">
                    <li @click="setFocus('')">Alle Schwerpunkte</li>
                    <li :value="option" :key="option" v-for="option of focusoptions" @click="setFocus(option)">{{ option }}</li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-4">
                <button @click="onEdit" v-if="!edit" class="btn-edit">Bearbeiten</button>
                <button @click="onEditStop" v-if="edit" class="btn-save">Bearbeiten beenden</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="container box-list-outer">
      <div class="row justify-content-center">
        <div class="col-lg-12" v-if="filteredtrainers.length == 0">
          <div class="no-results">Keine Ergebnisse</div>
        </div>
        <!-- VORLAGE -->

        <TrainerItem @changed="onChanged" :edit="edit" :trainer="trainer" :key="trainer.id" v-for="trainer of filteredtrainers"></TrainerItem>
        <div class="col-lg-12 box new" @click="newItem" v-if="edit"><Icon :path="mdiPlus" /></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue';
import { mdiChevronUp, mdiChevronRight, mdiPlus } from '@mdi/js';

import { useStore } from 'vuex';
import { APIResult } from '@/store/api';
import TrainerItem from '@/components/TrainerItem.vue';

type TrainerRecord = {
  id: number;
  name: string;
  ort: string;
  schwerpunkt: string;
  referenz: string;
  feedback: string;
  tagsatz: string;
  tagsatzcomment: string;
  url: string;
};

export default defineComponent({
  components: {
    TrainerItem,
  },
  setup() {
    const store = useStore();
    const trainers = ref<Array<TrainerRecord>>([]);

    onMounted(() => {
      store.dispatch('fetchTrainers').then((res: APIResult) => {
        trainers.value = res.data.message;
      });
    });

    const onChanged = () => {
      store.dispatch('fetchTrainers').then((res: APIResult) => {
        trainers.value = res.data.message;
      });
    };

    const filteredtrainers = computed(() => {
      return trainers.value.filter(
        (item) => (ort.value == '' || item.ort == ort.value) && (focus.value == '' || item.schwerpunkt.includes(focus.value))
      );
    });

    const focusoptions = ['Coaching', 'Sprachtraining', 'Consulting', 'Flipchart', 'Management', 'Führung', 'Training', 'Rethorik'];
    const focus = ref('');
    const setFocus = (value: string) => {
      focus.value = value;
    };

    const ort = ref('');
    const setOrt = (value: string) => {
      ort.value = value;
    };

    const edit = ref(false);
    const onEdit = () => {
      edit.value = true;
    };
    const onEditStop = () => {
      edit.value = false;
    };

    const newItem = () => {
      trainers.value.push({
        id: 0,
        name: '',
        ort: '',
        schwerpunkt: '',
        referenz: '',
        feedback: '',
        tagsatz: '',
        tagsatzcomment: '',
        url: '',
      });
    };

    return {
      mdiChevronUp,
      mdiChevronRight,
      mdiPlus,
      filteredtrainers,
      focusoptions,
      setOrt,
      setFocus,
      ort,
      focus,
      onChanged,
      onEdit,
      onEditStop,
      newItem,
      edit,
    };
  },
});
</script>
